import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../../services/form-field-control.service';
import { FormField } from '../../../../shared/form-field/form-field';

@Component({
  standalone: false,
  selector: 'name-info',
  templateUrl: 'name-info.template.html',
  styleUrls: ['name-info.scss'],
  providers: [FormFieldControlService],
})
export class NameInfoComponent implements OnInit {
  @Input() formFields: FormField<string>[] = [];
  form: FormGroup;

  constructor(private qcs: FormFieldControlService) {}

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
  }

  onSubmit() {
    // functionality for on submit
  }
}
